import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import DailyForecast from "./Components/DailyForecast";
import HourlyForecast from "./Components/HourlyForecast";
import TodayFocasting from "./Components/TodayFocasting";

import * as serviceCaller from "./services";

function App() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [locationData, setLocationData] = useState([]);
  const [currentLocation, setCurrentLocation] = useState({});
  const [searchLocation, setSearchLocation] = useState({});
  const [input, setInput] = useState("");
  const [inputCountry, setInputCountry] = useState("");
  const [visible, setVisible] = useState(true);

  const handleSearchLocation = async (data) => {
    // setInput("");
    // setInputCountry("");
    try {
      let res = await serviceCaller.getLocationName(data);
      console.log("locationdata", res.data);
      if (res.data.cod == 200) {
        setVisible(true);
        setSearchLocation(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getLocation = async () => {
    try {
      let res = await axios.get(`https://geolocation-db.com/json/`);
      console.log("geolocation", res.data);
      setLocationData(res.data);
      let response = await serviceCaller.getCurrentLocationWeather(res.data);
      console.log("getCurrentLocationWeather", response.data);
      setCurrentLocation(response.data);

      let locationResponse = await serviceCaller.getLocationName(res.data);

      console.log("locationResponse.data", locationResponse.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetCoordinates = async (data) => {
    setInput(data.name);
    setInputCountry(data.sys.country);
    setVisible(false);
    let response = await serviceCaller.getSearchCurrentLocationWeather(
      data.coord
    );
    console.log("getCurrentLocationWeather t", response.data);
    setCurrentLocation(response.data);
  };
  const inputClear = () => {
    setInput("");
    setInputCountry("");
  };
  useEffect(() => {
    getLocation();
    handleSearchLocation();
  }, []);

  if (!currentLocation.current) {
    return (
      <>
        <div className="text-center">
          <img src="/images/loader.gif"/>
        </div>
      </>
    );
  }
  return (
    <>
      <section className="container">
        <div className="flex space-between">
          <aside className="aside-container">
            <TodayFocasting
              forcastData={currentLocation}
              input={input}
              locationName={locationData}
              inputCountry={inputCountry}
            />
          </aside>
          <main className="main-container position-relative">
            <div className="flex space-between mb-4">
              <h2>Weather Forecasting</h2>
              <div className="position-relative">
                <form onSubmit={handleSubmit(handleSearchLocation)}>
                  <input
                    type="text"
                    placeholder="search new places"
                    className="input-field"
                    {...register("location", { required: true })}
                    defaultValue={input ? `${input}, ${inputCountry}` : ""}
                    onClick={() => inputClear}
                  />
                  <button
                    type="submit"
                    className="absolute-search-position position-absolute"
                  >
                    search
                  </button>
                  <div className="position-absolute absolute-loaction-position mb-2">
                    {errors.location && (
                      <span className="error-message">
                        Not found. To make search more precise put the location
                      </span>
                    )}
                    {visible
                      ? !errors.location && (
                          <div className="hourly-bg-container">
                            {searchLocation.list === [] ? (
                              <span className="error-message">
                                Not found. To make search more precise put the
                                location
                              </span>
                            ) : (
                              ""
                            )}
                            {searchLocation.list &&
                              searchLocation.list.map((location) => (
                                <div>
                                  <div
                                    className="flex align-items-center cursor-pointer pt-2 pb-2"
                                    key={location.id}
                                    onClick={() =>
                                      handleGetCoordinates(location)
                                    }
                                  >
                                    <img
                                      src="./images/45-degrees.png"
                                      className="location-icon"
                                      alt="weather-icon"
                                    />
                                    <h5 className="ml-3">
                                      {location.name},
                                      <span className="ml-1">
                                        {location.sys.country}
                                      </span>
                                    </h5>

                                    <h6 className="ml-3 temp-color">
                                      {Number(location.main.temp - 273).toFixed(
                                        0
                                      )}
                                      <sup className="temp-color">o</sup>C
                                    </h6>
                                    <small className="ml-5">
                                      <span>
                                        {Number(location.coord.lat).toFixed(2)}
                                      </span>
                                      <span className="ml-2">
                                        {Number(location.coord.lon).toFixed(2)}
                                      </span>
                                    </small>
                                  </div>
                                  <hr />
                                </div>
                              ))}
                          </div>
                        )
                      : ""}
                  </div>
                </form>
              </div>
            </div>
            <DailyForecast
              currentLocation={currentLocation}
              locationName={locationData}
              input={input}
              inputCountry={inputCountry}
            />
            <HourlyForecast
              currentLocation={currentLocation}
              locationName={locationData}
              input={input}
              inputCountry={inputCountry}
            />
          </main>
        </div>
      </section>
    </>
  );
}

export default App;
